"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var colorsV2_1 = __importDefault(require("../../../../assets/jss/colorsV2"));
var constants_1 = __importDefault(require("../../../../config/constants"));
var actions_1 = require("../../../../redux/reducers/authentication/actions");
var AccessibleDisabledButton_1 = __importDefault(require("../../../../shared/components/button/AccessibleDisabledButton"));
var auth_service_1 = require("../../../../utils/auth-service");
var framework_1 = require("../../../../widgets/framework");
var AccountReactivateDialog_1 = __importDefault(require("../AccountReactivateDialog"));
var AccountReactivateEmailSentDialog_1 = __importDefault(require("../AccountReactivateEmailSentDialog"));
var ResendActivationDialog_1 = __importDefault(require("../resend-activation/ResendActivationDialog"));
var ResendActivationEmailSentDialog_1 = __importDefault(require("../resend-activation/ResendActivationEmailSentDialog"));
var styles_1 = __importDefault(require("../styles"));
var validations_1 = require("../validations");
var LoginForm = function (_a) {
    var successCallback = _a.successCallback, disableAutofill = _a.disableAutofill;
    var show = (0, react_redux_1.useSelector)(function (state) { return state.accountReactivation; }).show;
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.authentication; }), resendMailSent = _b.resendMailSent, emailAddress = _b.emailAddress;
    var theme = (0, core_1.useTheme)();
    var classes = (0, styles_1.default)(theme)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var _c = (0, react_1.useState)(''), email = _c[0], setEmail = _c[1];
    var _d = (0, react_1.useState)(false), showResendDialog = _d[0], setShowResendDialog = _d[1];
    var _e = (0, react_1.useState)(''), password = _e[0], setPassword = _e[1];
    var _f = (0, react_1.useState)(false), rememberMe = _f[0], setRememberMe = _f[1];
    var _g = (0, react_1.useState)(false), formIsValid = _g[0], setFormIsValid = _g[1];
    var _h = (0, react_1.useState)(false), reactivationEmailDialog = _h[0], setReactivationEmailDialog = _h[1];
    var _j = (0, react_1.useState)(false), emptyEmailField = _j[0], setEmptyEmailField = _j[1];
    var _k = (0, react_1.useState)(false), emptyPasswordField = _k[0], setEmptyPasswordField = _k[1];
    var _l = (0, react_1.useState)(false), isEmailFieldFocused = _l[0], setIsEmailFieldFocused = _l[1];
    var _m = (0, react_1.useState)(false), isPasswordFieldFocused = _m[0], setIsPasswordFieldFocused = _m[1];
    var emailField = {
        type: 'email',
        key: 'email',
        value: email,
        isRequired: true,
        get fieldValue() {
            return email;
        },
        validationSchema: validations_1.loginEmailSchema,
        label: t('login.email')
    };
    var rememberMeField = {
        type: 'boolean',
        key: 'rememberMe',
        label: t('login.rememberMe'),
        value: rememberMe,
        get placeholder() {
            return t('login.rememberMe');
        },
        get fieldValue() {
            return rememberMe;
        },
        validationSchema: validations_1.loginRememberMeSchema
    };
    var passwordField = {
        type: 'password',
        key: 'password',
        value: password,
        isRequired: true,
        showPassword: true,
        secureTextEntry: true,
        get fieldValue() {
            return password;
        },
        validationSchema: validations_1.loginPasswordSchema,
        disabledAutofill: disableAutofill,
        label: t('login.password')
    };
    var labelProps = {
        useAlternateTextField: true,
        isRequiredLabel: true,
        labelStyle: {
            margin: theme.spacing(0, 2, 1),
            color: colorsV2_1.default.palette.neutralsN700.hex()
        }
    };
    var onSubmit = function () {
        if (email.length > 0 && password.length > 0) {
            dispatch((0, actions_1.login)(email, password, rememberMe, successCallback));
        }
    };
    var successCall = function (mail) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, auth_service_1.AuthService.unSuspend(mail)];
                case 1:
                    _a.sent();
                    setReactivationEmailDialog(true);
                    return [3, 3];
                case 2:
                    e_1 = _a.sent();
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var okayCallback = function () {
        setReactivationEmailDialog(false);
        onNavigate('LOGIN');
    };
    var onKeyDown = function (event) {
        if (event.key === 'Enter') {
            onSubmit();
        }
    };
    var onEmailChange = function (value) {
        setEmptyEmailField(value.length === 0);
        setEmail(value);
        setFormIsValid(validations_1.loginSchema.isValidSync({ email: value, password: password }));
    };
    var onPasswordChange = function (value) {
        setEmptyPasswordField(value.length === 0);
        setPassword(value);
        setFormIsValid(validations_1.loginSchema.isValidSync({ email: email, password: value }));
    };
    var toggleRememberMe = function (value) {
        setRememberMe(value);
    };
    var onEmailFieldFocus = function () { return setIsEmailFieldFocused(true); };
    var onEmailFieldBlur = function () {
        setIsEmailFieldFocused(false);
    };
    var onPasswordFieldFocus = function () { return setIsPasswordFieldFocused(true); };
    var onPasswordFieldBlur = function () {
        setIsPasswordFieldFocused(false);
    };
    var onNavigate = function (action) { return function () {
        var appNavigate = {
            action: action
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    }; };
    var onNavigateForgotPassword = function () { return function () { return __awaiter(void 0, void 0, void 0, function () {
        var appNavigate;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, dispatch((0, actions_1.reset)())];
                case 1:
                    _a.sent();
                    appNavigate = {
                        action: 'FORGOT_PASSWORD'
                    };
                    framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
                    return [2];
            }
        });
    }); }; };
    var gotoReactivate = function () {
        setShowResendDialog(true);
    };
    var closeResendActivationDialog = function () {
        setShowResendDialog(false);
    };
    var closeEmailSentDialog = function () {
        dispatch((0, actions_1.resetResendMail)());
        onNavigate('LOGIN');
    };
    var getEmailHelpMessage = function () {
        if (email.length > 0 && !validations_1.loginEmailSchema.isValidSync(email)) {
            return t('login.emailError');
        }
        return t('login.usernameWarning');
    };
    return (react_1.default.createElement(core_1.Grid, { item: true, sm: 10, md: 10 },
        react_1.default.createElement(core_1.Typography, { variant: "body1", style: { color: colorsV2_1.default.palette.neutralsN900.hex(), margin: theme.spacing(3, 0, 2, 0) } }, t('login.requiredInformation')),
        react_1.default.createElement(package_1.FieldRenderer, { field: emailField, onChange: onEmailChange, labelProps: labelProps, inputProps: {
                autoComplete: "email",
                fullWidth: true,
                error: emptyEmailField,
                onBlur: onEmailFieldBlur,
                onFocus: onEmailFieldFocus,
                variant: constants_1.default.FIELDS_VARIANT,
                style: { marginBottom: theme.spacing() },
                helperText: getEmailHelpMessage(),
                hideAriaHelperText: false
            } }),
        react_1.default.createElement(package_1.FieldRenderer, { field: passwordField, onChange: onPasswordChange, labelProps: labelProps, inputProps: {
                fullWidth: true,
                onBlur: onPasswordFieldBlur,
                onFocus: onPasswordFieldFocus,
                error: emptyPasswordField,
                variant: constants_1.default.FIELDS_VARIANT,
                style: { marginBottom: theme.spacing(2) },
                onKeyDown: onKeyDown,
                helperText: emptyPasswordField ? t('login.emptyPasswordError') : null,
                hideAriaHelperText: false
            } }),
        react_1.default.createElement("div", { className: classes.forgotContainer },
            react_1.default.createElement("div", { className: classes.remember },
                react_1.default.createElement(package_1.FieldRenderer, { field: rememberMeField, onChange: toggleRememberMe, inputProps: {
                        'aria-label': t('login.rememberMe'),
                        style: { marginTop: 10 }
                    } })),
            react_1.default.createElement("div", { className: classes.forgot },
                react_1.default.createElement(core_1.Tooltip, { title: t('login.forgotPassword'), disableFocusListener: true, "aria-label": t('login.forgotPassword') },
                    react_1.default.createElement(core_1.Button, { variant: 'text', onClick: onNavigateForgotPassword(), "aria-label": t('login.forgotPassword'), style: { padding: theme.spacing(0, 1, 1.5) } },
                        react_1.default.createElement(core_1.Typography, { variant: "body2", className: classes.primaryText, style: { textDecoration: 'underline', textTransform: 'none' } }, t('login.forgotPassword')))))),
        react_1.default.createElement(AccountReactivateEmailSentDialog_1.default, { email: email, show: reactivationEmailDialog, okayCallback: okayCallback }),
        react_1.default.createElement(AccountReactivateDialog_1.default, { email: email, show: show, successCalback: successCall.bind(_this, email) }),
        react_1.default.createElement(ResendActivationDialog_1.default, { show: showResendDialog, onSuccessCallback: closeResendActivationDialog, closeReactivationDialog: closeResendActivationDialog }),
        react_1.default.createElement(ResendActivationEmailSentDialog_1.default, { show: resendMailSent, email: emailAddress, okayCallback: closeEmailSentDialog }),
        react_1.default.createElement(core_1.Tooltip, { title: t('login.resendActivation'), disableFocusListener: true, "aria-label": t('login.resendActivation') },
            react_1.default.createElement(core_1.Button, { variant: 'text', onClick: gotoReactivate, "aria-label": t('login.resendActivation'), style: { display: 'block', margin: '16px auto 0' } },
                react_1.default.createElement(core_1.Typography, { variant: "body2", className: classes.primaryText, style: { textDecoration: 'underline', textTransform: 'none' } }, t('login.resendActivation')))),
        react_1.default.createElement("div", { className: classes.register },
            react_1.default.createElement(core_1.Typography, { color: "textPrimary", variant: "body1", style: { margin: theme.spacing(2, 0, 1) } }, t('login.needToCreateAccount')),
            react_1.default.createElement(core_1.Tooltip, { title: 'Register Here', disableFocusListener: true, "aria-label": "Register Here" },
                react_1.default.createElement(core_1.Button, { onClick: onNavigate('REGISTER'), "aria-label": "Register Here" },
                    react_1.default.createElement(core_1.Typography, { variant: "overline", color: "primary" }, t('login.registerHere')),
                    react_1.default.createElement(core_1.Icon, { color: "primary" }, "how_to_reg")))),
        react_1.default.createElement(AccessibleDisabledButton_1.default, { size: "large", variant: "contained", fullWidth: true, disabled: !formIsValid, color: "primary", onClick: onSubmit, "aria-label": "Sign in", type: "submit", style: { display: 'block', margin: '40px auto 0', width: 'auto' } }, t('login.signIn'))));
};
exports.default = LoginForm;
//# sourceMappingURL=LoginForm.js.map